import { shouldShowSwitchEditorButton } from 'src/views/switch-editor/switch-editor.utils';
const { redirectToNewEditor } = require('../../init-top-bar');
const statusNotification = require('../../status');
const EditorFacade = require('../../../../facade/editor/editor');
const DesignFacade = require('../../../../facade/design/design');
const ImagesFactory = require('../../../../factory/images');

module.exports = Backbone.View.extend({
  initialize: function (opts = {}) {
    if (INKIVE.C.IS_MOBILE) {
      return;
    }

    this.tool = INKIVE.Tool.getInstance();
    _.bindAll(this, 'initMenu', 'handleMenuOption', 'calculateImageQuality', 'lockEvent', 'doLock',
      'addFileMenuElement');

    INKIVE.C.IS_AUTO_SAVE = localStorage.getItem('autosave') !== 'false';
    this.globalLock = localStorage.getItem('lock_elements') === 'true';

    EditorFacade.once('page.move_to', this.doLock);
    EditorFacade.on('page.save_from_keyboard', this.saveEvent);
    EditorFacade.on('add.filemenu', this.addFileMenuElement);

    this.initializeItems();
    this.initMenu();
    EditorFacade.trigger('created.filemenu');

    opts.recreated || EditorFacade.on('destroy.filemenu', () => INKIVE.ContextMenu.destroyMenu());
  },

  getMenuPosition: function () {
    return {
      top: $('header').height() + 6,
      left: $('[data-action=file]').offset().left
    };
  },

  getCanvas: function () {
    this.tool = this.tool || INKIVE.Tool.getInstance();
    this.canvas = this.canvas || this.tool.editor.canvas;

    return this.canvas;
  },

  initMenu: function () {
    const selector = '[data-action=file]';

    $.contextMenu({
      selector,
      trigger: 'left',
      hideOnSecondTrigger: true,
      events: {
        hide: function () {
          $(selector).removeClass('context-menu-active').blur();
          return true;
        }
      },
      position: _.bind(function (opt) {
        opt.$menu.css(this.getMenuPosition());
      }, this),
      build: _.bind(function ($button) {
        $button.one('contextmenu:visible', _.bind(function () {
          const $contextMenu = $('.context-menu-root');

          _.each(this.items, function (item, key) {
            $contextMenu.find('.context-menu-' + key).attr('data-action', key);
          });
        }, this));
        return {
          callback: this.handleMenuOption,
          items: this.items
        };
      }, this)
    });
  },

  handleMenuOption: function (key, options, e) {
    this.canvas = this.getCanvas();

    switch (key) {
      case 'save':
        this.saveEvent(e);
        break;
      case 'imgquality':
        this.imgqualityEvent(e);
        break;
      case 'grid':
        this.gridEvent(e);
        break;
      case 'rulerandguides':
        this.rulerAndGuidesEvent(e);
        break;
      case 'bleed':
        this.bleedEvent(e, false);
        break;
      case 'bleed_manage':
        this.bleedEvent(e, true);
        break;
      case 'safearea':
        this.safeAreaEvent(e);
        break;
      case 'autosave':
        this.autoSaveEvent(e);
        break;
      case 'lockpage':
        this.lockEvent(e);
        break;
      case 'translate':
        this.translateEvent();
        break;
      case 'tryNewEditor':
        this.tryNewEditorEvent();
        break;
      default:
        this['handleCustomEvent' + key]();
        break;
    }
  },

  saveEvent: function (event) {
    const $saveButton = $(event.currentTarget);
    const translate = INKIVE.TranslateHelper.translate;

    $saveButton.addClass('context-menu-disabled');
    statusNotification.display(translate('general.saving'), null, true);
    EditorFacade.handle('page', 'save', { confirm_draft: true, force_save: true }).then((quiet) => {
      INKIVE.hasEditorUnsavedChanges = false;
      $saveButton.removeClass('context-menu-disabled');
      statusNotification.display(quiet
        ? ''
        : translate('advice.content.nothing_to_save'));
    }, (error) => {
      statusNotification.display(error || translate('common.error'));
    });
  },

  tryNewEditorEvent: function () {
    redirectToNewEditor();
  },

  autoSaveEvent: function () {
    INKIVE.C.IS_AUTO_SAVE = !INKIVE.C.IS_AUTO_SAVE;
    localStorage.setItem('autosave', INKIVE.C.IS_AUTO_SAVE);
    INKIVE.Tool.autoSave();
  },

  lockEvent: function () {
    const globalLock = this.globalLock = !this.globalLock;

    localStorage.setItem('lock_elements', globalLock + '');
    this.doLock();
  },

  translateEvent: function () {
    INKIVE.EditorFacade.handle('translations', 'display');
  },

  doLock: function () {
    $('#svgcontent').toggleClass('global-locked', this.globalLock);
    this.canvas && this.canvas.clearSelection();

    INKIVE.Menus.elementPopupMenu && INKIVE.Menus.elementPopupMenu.show(null, 'locked');
  },

  imgqualityEvent: function (opts) {
    const $imageQualityBoxGroup = $('#image-quality-box-group');
    const smartLoad = _.bind(function (image, count) {
      const url = ImagesFactory.getOriginalUrl(ImagesFactory.getImageUrl(image)) ||
        ImagesFactory.getOriginalUrl(image.getAttribute('xlink:href')) ||
        ImagesFactory.getOriginalUrl(image.getAttribute('data-original-href')) ||
        ImagesFactory.getImageUrl(image) ||
        image.getAttribute('xlink:href');

      count = count || 0;

      if (count++ > 5) {
        return;
      }

      url
        ? _.bind(_smartLoad, this)(url, image)
        : _.delay(_.partial(smartLoad, image, count), 500);
    }, this);

    opts = opts || {};

    if ($imageQualityBoxGroup.length) {
      this.canvas.runExtensions('removeImageQualityBox', {});
      return;
    }

    const $images = $('#svgcontent').find('image');

    this.imgqualityCalculated = 0;
    this.isimgQualityAcceptable = true;

    !INKIVE.C.IS_MOBILE && $images.length && INKIVE.Modal.togglePageLoader(true);
    EditorFacade.once('page.saving', _.partial(this.getCanvas().runExtensions, 'removeImageQualityBox'));

    this.getDynamoImagesInDesign().then(images => {
      $images.each((index, image) => {
        const url = ImagesFactory.getOriginalUrl(image.getAttribute('xlink:href')) ||
          ImagesFactory.getOriginalUrl(image.getAttribute('data-original-href'));

        const corsUrl = url && INKIVE.Helpers.getCORSSecureUrl(url);
        const originalImage = url && Array.isArray(images) && images.find(i => {
          return INKIVE.Helpers.getCORSSecureUrl(i.original.src) === corsUrl;
        });

        DesignFacade.trigger('image.check_quality.start', { id: image.id });

        if (originalImage) {
          opts = _.extend(opts, {
            image,
            originalImage
          });

          DesignFacade.trigger('image.check_quality.end', {
            id: image.id,
            isAcceptable: this.calculateImageQuality(opts)
          });
        } else {
          smartLoad(image);
        }
      });

      this.getCanvas().clearSelection();
      INKIVE.C.IS_MOBILE || INKIVE.Modal.togglePageLoader(false);
    });

    function _smartLoad (url, image) {
      ImagesFactory.smartLoad(url, {
        width: Infinity,
        height: Infinity
      }, _.bind(function (status, img) {
        opts = _.extend(opts, {
          image,
          originalImage: {
            original_width: img.width,
            original_height: img.height
          }
        });

        if (status === INKIVE.C.Status.success) {
          DesignFacade.trigger('image.check_quality.end', {
            id: image.id,
            isAcceptable: this.calculateImageQuality(opts)
          });
        } else {
          smartLoad(ImagesFactory.getOriginalUrl($('#svgcontent').find('#' + image.id).attr('xlink:href'), image));
        }
      }, this));
    }

    return $images.length;
  },

  getDynamoImagesInDesign: async function () {
    try {
      const endpoint = `business/projects/${INKIVE.C.BOOK.id}/images`;
      return await INKIVE.DesygnerApi.get(endpoint);
    } catch (err) {}

    return [];
  },

  calculateImageQuality: function (opts) {
    const minDPI = 300;

    const minWidth = opts.image.getAttribute('width') * minDPI / INKIVE.C.DPI;
    const minHeight = opts.image.getAttribute('height') * minDPI / INKIVE.C.DPI;
    const isAcceptable = opts.originalImage.original_width >= minWidth ||
      opts.originalImage.original_height >= minHeight;

    this.getCanvas().runExtensions('generateImageQualityBox', {
      elem: opts.image,
      isAcceptable
    });

    if (!isAcceptable) {
      this.isimgQualityAcceptable = false;
    }

    this.imgqualityCalculated++;

    if (this.imgqualityCalculated === $('#svgcontent').find('image').length && !opts.skipAdvice) {
      this.getCanvas().call('advice.show', this.isimgQualityAcceptable
        ? 'img-quality-acceptable'
        : 'low-img-quality-present');
    }

    return isAcceptable;
  },

  gridEvent: function () {
    const $gridButton = $('#ik-grid-snap');
    const action = $gridButton.is('.active')
      ? 'disableGrid'
      : 'enableGrid';

    $gridButton.toggleClass('active');
    this.canvas.runExtensions(action, {});
  },

  rulerAndGuidesEvent: function () {
    const isRulersAndGuidesShown = this.canvas.runExtensions(
      'isRulersAndGuidesShown',
      {}
    );
    const action = isRulersAndGuidesShown
      ? 'hideRulersAndGuides'
      : 'showRulersAndGuides';
    this.canvas.runExtensions('enableRuler', {});
    this.canvas.runExtensions(action, {});
    document.querySelector('#ruler-horizontal').style.left ||
      document.querySelector('#tool-panel #sidebar-resize-button').click();
  },

  bleedEvent: function (e, manage) {
    this.canvas.runExtensions('generateNewBleed', {});

    const bleed = this.canvas.runExtensions('getBleedValues', {});
    let hide = bleed.active;

    if (manage) {
      hide = false;
    }

    // Hide pages panel if open
    const $pagesPanel = $('#pages-panel .pages-panel');
    bleed.active ||
    ($pagesPanel.is('.pages-panel-opened') &&
      $pagesPanel.find('.btn-panel.btn-show-pages').trigger('click'));

    this.canvas.runExtensions(hide
      ? 'hideBleedClipper'
      : 'showBleedClipper', { keepDisabled: true, manage, recalculate: manage });
    this.canvas.runExtensions(hide
      ? 'disableGuideLine'
      : 'enableGuideLine', { keepVisible: true });
  },

  safeAreaEvent: function () {
    this.canvas.runExtensions(document.querySelector('.safeAreaGroup')
      ? 'hideSafeArea'
      : 'showSafeArea');
  },

  addFileMenuElement: function (params) {
    const items = {};
    let pos = 0;

    _.each(this.items, function (item, id) {
      pos++;
      items[id] = item;
      if (pos === params.position) {
        items[params.id] = {
          name: params.label,
          className: 'context-menu-' + params.id
        };
      }
    });

    this.items = items;
    this['handleCustomEvent' + params.id] = params.callback;
  },

  initializeItems: function () {
    this.items = this.items || {
      save: {
        name: INKIVE.TranslateHelper.translate('general.save'),
        className: 'context-menu-save'
      },
      autosave: {
        name: INKIVE.TranslateHelper.translate('top_submenu.file.autosave'),
        className: 'context-menu-auto-save',
        icon: function (opt, $itemElement, itemKey, item) {
          INKIVE.C.IS_AUTO_SAVE && !INKIVE.C.IS_UNDER_REVIEW && !INKIVE.C.REVIEW_MODE &&
            $itemElement.html('<i class="fa fa-check"></i><span>' + item.name + '</span>');
        }
      },
      translate: {
        name: 'Translate', // TODO INKIVE.TranslateHelper.translate('top_submenu.file.translate'),
        className: 'context-menu-translate'
      },
      sep1: '---------',
      lockpage: {
        name: INKIVE.TranslateHelper.translate('top_submenu.file.lock_page'),
        icon: _.bind(function (opt, $itemElement, itemKey, item) {
          this.globalLock && $itemElement.html('<i class="fa fa-check"></i><span>' + item.name + '</span>');
        }, this)
      },
      grid: {
        name: INKIVE.TranslateHelper.translate('top_submenu.file.show_grid'),
        className: 'context-menu-grid',
        icon: function (opt, $itemElement, itemKey, item) {
          $('#ik-grid-snap').is('.active') && $itemElement.html(
            '<i class="fa fa-check"></i><span>' + item.name + '</span>');
        }
      },
      rulerandguides: {
        name: INKIVE.TranslateHelper.translate('top_submenu.file.show_ruler'),
        className: 'context-menu-rulerandguides',
        icon: function (opt, $itemElement, itemKey, item) {
          const canvas = INKIVE.Tool.getInstance().editor.canvas;
          const isRulersAndGuidesShown = canvas.runExtensions(
            'isRulersAndGuidesShown',
            {}
          );
          if (isRulersAndGuidesShown) {
            $itemElement.html(
              '<i class="fa fa-check"></i><span>' + item.name + '</span>'
            );
          }
        }
      },
      sep2: '---------',
      bleed_manage: {
        name: INKIVE.TranslateHelper.translate('top_submenu.file.manage_bleed'),
        className: 'context-menu-bleed-manage'
      },
      safearea: {
        name: INKIVE.TranslateHelper.translate('top_submenu.file.show_safearea'),
        className: 'context-menu-safearea',
        icon: function (opt, $itemElement, itemKey, item) {
          !!document.querySelector('.safeAreaGroup') && $itemElement.html(
            '<i class="fa fa-check"></i><span>' + item.name + '</span>');
        }
      },
      bleed: {
        name: INKIVE.TranslateHelper.translate('top_submenu.file.only_show_bleed'),
        className: 'context-menu-bleed',
        icon: function (opt, $itemElement, itemKey, item) {
          if (document.querySelector('.printGuideLineGroup>.bleed_area') &&
            !document.querySelector('header').classList.contains('disabled')) {
            $itemElement.html('<i class="fa fa-check"></i><span>' + item.name + '</span>');
          }
        }
      },
      sep3: '---------',
      imgquality: {
        name: INKIVE.TranslateHelper.translate('top_submenu.file.check_image_quality'),
        className: 'context-menu-imgquality',
        icon: function (opt, $itemElement, itemKey, item) {
          $('#image-quality-box-group').length && $itemElement.html(
            '<i class="fa fa-check"></i><span>' + item.name + '</span>');
        }
      }
    };

    if (shouldShowSwitchEditorButton()) {
      this.items.tryNewEditor = {
        name: INKIVE.TranslateHelper.translate('top_submenu.file.try_new_editor'),
        className: 'context-menu-new-editor',
        icon: function (opt, $itemElement, itemKey, item) {
          $itemElement.html(
            '<icon> <svg fill="#fff"> <use xlink:href="#magic-pen"></use> </svg> </icon> <span>' + item.name + '</span>');
        }
      };
    }

    // TODO: handle this base on a flag to be defined
    const config = INKIVE.C.WHITE_LABEL_CONFIGURATION;
    const parent = config.parent_company || config.parent_domain;
    parent === 'emerson' || INKIVE.C.TRANSLATION_DATA || (delete this.items.translate);
  }
});
